import React, { Component } from "react";
import { BASE_URL } from "../common/common";

const API_URL = BASE_URL;

const imgUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http")) return `${path}?ngrok-skip-browser-warning=true`;
  const cleanPath = path.startsWith("/") ? path.slice(1) : path;
  return `${API_URL}/${cleanPath}?ngrok-skip-browser-warning=true`;
};

// ── Rich Text Editor ────────────────────────
class RichTextEditor extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = { showLinkInput: false, linkUrl: "" };
  }

  componentDidMount() {
    if (this.ref.current) this.ref.current.innerHTML = this.props.value || "";
  }

  exec = (cmd, value = null) => {
    this.ref.current.focus();
    document.execCommand(cmd, false, value);
    this.notify();
  };

  notify = () => {
    if (this.ref.current) this.props.onChange(this.ref.current.innerHTML);
  };
  handleInput = () => this.notify();

  insertLink = () => {
    const { linkUrl } = this.state;
    if (!linkUrl.trim()) return;
    const url = linkUrl.startsWith("http") ? linkUrl : `https://${linkUrl}`;
    this.exec("createLink", url);
    this.setState({ showLinkInput: false, linkUrl: "" });
  };

  render() {
    const { showLinkInput, linkUrl } = this.state;
    return (
      <div style={rt.wrapper}>
        <div style={rt.toolbar}>
          <select
            style={rt.select}
            onChange={(e) => {
              this.exec("formatBlock", e.target.value);
              e.target.value = "p";
            }}
          >
            <option value="p">Paragraph</option>
            <option value="h1">Heading 1</option>
            <option value="h2">Heading 2</option>
            <option value="h3">Heading 3</option>
            <option value="h4">Heading 4</option>
            <option value="pre">Code Block</option>
            <option value="blockquote">Blockquote</option>
          </select>
          <select
            style={rt.select}
            onChange={(e) => {
              this.exec("fontSize", e.target.value);
              e.target.value = "";
            }}
          >
            <option value="">Size</option>
            {[1, 2, 3, 4, 5, 6, 7].map((n) => (
              <option key={n} value={n}>
                {["8px", "10px", "12px", "14px", "18px", "24px", "36px"][n - 1]}
              </option>
            ))}
          </select>
          <span style={rt.sep} />
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("bold")}
          >
            <b>B</b>
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("italic")}
          >
            <i>I</i>
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("underline")}
          >
            <u>U</u>
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("strikeThrough")}
          >
            <s>S</s>
          </button>
          <span style={rt.sep} />
          <label style={rt.colorLabel}>
            A
            <input
              type="color"
              style={rt.colorInput}
              onChange={(e) => this.exec("foreColor", e.target.value)}
            />
          </label>
          <label style={{ ...rt.colorLabel, background: "#ffe082" }}>
            H
            <input
              type="color"
              style={rt.colorInput}
              onChange={(e) => this.exec("hiliteColor", e.target.value)}
            />
          </label>
          <span style={rt.sep} />
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("justifyLeft")}
          >
            &#8676;
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("justifyCenter")}
          >
            &#8652;
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("justifyRight")}
          >
            &#8677;
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("justifyFull")}
          >
            &#8801;
          </button>
          <span style={rt.sep} />
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("insertUnorderedList")}
          >
            • List
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("insertOrderedList")}
          >
            1. List
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("indent")}
          >
            &#8677;
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("outdent")}
          >
            &#8676;
          </button>
          <span style={rt.sep} />
          <button
            type="button"
            style={rt.btn}
            onClick={() =>
              this.setState((p) => ({ showLinkInput: !p.showLinkInput }))
            }
          >
            Link
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("unlink")}
          >
            Unlink
          </button>
          <span style={rt.sep} />
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("insertHorizontalRule")}
          >
            &#8213;
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("removeFormat")}
          >
            Clear
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("undo")}
          >
            &#8617;
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("redo")}
          >
            &#8618;
          </button>
        </div>
        {showLinkInput && (
          <div style={rt.linkRow}>
            <input
              type="text"
              placeholder="https://example.com"
              value={linkUrl}
              onChange={(e) => this.setState({ linkUrl: e.target.value })}
              onKeyDown={(e) => {
                if (e.key === "Enter") this.insertLink();
              }}
              style={rt.linkInput}
            />
            <button type="button" style={rt.linkBtn} onClick={this.insertLink}>
              Insert
            </button>
            <button
              type="button"
              style={rt.cancelBtn}
              onClick={() =>
                this.setState({ showLinkInput: false, linkUrl: "" })
              }
            >
              Cancel
            </button>
          </div>
        )}
        <div
          ref={this.ref}
          contentEditable
          suppressContentEditableWarning
          onInput={this.handleInput}
          style={rt.editor}
        />
        <div style={rt.footer}>
          Characters: {this.ref.current ? this.ref.current.innerText.length : 0}
          <span style={{ marginLeft: "12px", color: "#bbb" }}>
            Tip: Select text first, then apply formatting
          </span>
        </div>
      </div>
    );
  }
}

const rt = {
  wrapper: {
    border: "1px solid #ddd",
    borderRadius: "8px",
    overflow: "hidden",
  },
  toolbar: {
    display: "flex",
    flexWrap: "wrap",
    gap: "3px",
    padding: "8px 10px",
    background: "#f8f8f8",
    borderBottom: "1px solid #e8e8e8",
    alignItems: "center",
  },
  btn: {
    padding: "4px 9px",
    background: "white",
    border: "1px solid #ddd",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "12px",
    minWidth: "28px",
    textAlign: "center",
  },
  select: {
    padding: "4px 6px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "12px",
    background: "white",
    cursor: "pointer",
    outline: "none",
  },
  sep: {
    width: "1px",
    height: "20px",
    background: "#ddd",
    margin: "0 3px",
    flexShrink: 0,
  },
  colorLabel: {
    padding: "3px 8px",
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "700",
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  colorInput: {
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    cursor: "pointer",
    border: "none",
  },
  linkRow: {
    display: "flex",
    gap: "8px",
    padding: "8px 10px",
    background: "#f0f7ff",
    borderBottom: "1px solid #bbdefb",
    alignItems: "center",
  },
  linkInput: {
    flex: 1,
    padding: "6px 10px",
    border: "1px solid #bbdefb",
    borderRadius: "6px",
    fontSize: "13px",
    outline: "none",
  },
  linkBtn: {
    padding: "6px 14px",
    background: "#1565c0",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "12px",
    cursor: "pointer",
    fontWeight: "600",
  },
  cancelBtn: {
    padding: "6px 14px",
    background: "#f0f2f5",
    color: "#555",
    border: "1px solid #ddd",
    borderRadius: "6px",
    fontSize: "12px",
    cursor: "pointer",
  },
  editor: {
    minHeight: "180px",
    padding: "16px",
    fontSize: "14px",
    lineHeight: "1.8",
    outline: "none",
    fontFamily: "Arial, sans-serif",
    background: "white",
  },
  footer: {
    padding: "6px 12px",
    background: "#fafafa",
    borderTop: "1px solid #f0f0f0",
    fontSize: "11px",
    color: "#aaa",
    display: "flex",
    alignItems: "center",
  },
};

// ── Main Component ──────────────────────────
class AboutUs extends Component {
  constructor(props) {
    super(props);

    const emptyAbout = () => ({
      title: "",
      subtitle: "",
      description: "",
      images: [],
      saving: false,
    });
    const emptyMV = () => ({ heading: "", description: "", saving: false });
    const emptyTarget = () => ({
      label: "",
      value: "",
      imagePreview: null,
      imageFile: null,
      saving: false,
    });
    const emptyCoreValue = () => ({
      title: "",
      description: "",
      saving: false,
    });
    const emptyAB = () => ({ title: "", description: "", saving: false });

    this.state = {
      activeTab: "banner",
      bannerSize: 0,

      // Banner
      bannerView: "list",
      bannerList: [],
      bannerLoading: false,
      bannerTitle: "About",
      bannerImagePreview: null,
      bannerFile: null,
      bannerSaving: false,
      editingBanner: null,
      bannerDescription: "",

      // About Section
      aboutView: "list",
      aboutList: [],
      aboutLoading: false,
      aboutForm: emptyAbout(),
      editingAbout: null,

      // Mission & Vision
      mvView: "list",
      mvList: [],
      mvLoading: false,
      mvForm: emptyMV(),
      editingMV: null,

      // Targets
      targetView: "list",
      targetList: [],
      targetLoading: false,
      targetForm: emptyTarget(),
      editingTarget: null,

      // Core Values
      cvView: "list",
      cvList: [],
      cvLoading: false,
      cvForm: emptyCoreValue(),
      editingCV: null,

      // ✅ About Cards — properly initialized
      abView: "list",
      abList: [],
      abLoading: false,
      abForm: emptyAB(),
      editingAB: null,

      successMessage: "",
      errorMessage: "",
    };

    this.emptyAbout = emptyAbout;
    this.emptyMV = emptyMV;
    this.emptyTarget = emptyTarget;
    this.emptyCoreValue = emptyCoreValue;
    this.emptyAB = emptyAB;
  }

  componentDidMount() {
    this.fetchBanners();
    this.fetchAbout();
    this.fetchMV();
    this.fetchTargets();
    this.fetchCoreValues();
    this.fetchAboutCard();
  }

  showSuccess = (msg) => {
    this.setState({ successMessage: msg, errorMessage: "" });
    setTimeout(() => this.setState({ successMessage: "" }), 3000);
  };
  showError = (msg) => {
    this.setState({ errorMessage: msg, successMessage: "" });
    setTimeout(() => this.setState({ errorMessage: "" }), 4000);
  };

  // ════════════════════
  //  BANNER
  // ════════════════════

  fetchBanners = async () => {
    this.setState({ bannerLoading: true });
    try {
      const res = await fetch(`${API_URL}/api/banners/getBanners`, {
        method: "GET",
        headers: { "ngrok-skip-browser-warning": "true" },
      });
      const json = await res.json();
      if (json.status) {
        const filtered = (json.data || []).filter(
          (b) => b.Page_Name?.toLowerCase() === "about",
        );
        this.setState({
          bannerSize: filtered.length,
          bannerList: filtered,
          bannerLoading: false,
        });
      } else {
        this.setState({ bannerLoading: false });
      }
    } catch {
      this.setState({ bannerLoading: false });
      this.showError("Cannot connect to API.");
    }
  };

  openBannerForm = (banner = null) => {
    this.setState({
      bannerView: "form",
      editingBanner: banner,
      bannerTitle: banner?.Page_Name || "About",
      bannerDescription: banner?.Description || banner?.description || "",
      bannerImagePreview: null,
      bannerFile: null,
    });
  };

  goToBannerList = () => {
    this.setState({ bannerView: "list", editingBanner: null });
    this.fetchBanners();
  };

  handleBannerImg = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () =>
      this.setState({ bannerImagePreview: reader.result, bannerFile: file });
    reader.readAsDataURL(file);
  };

  saveBanner = async () => {
    const { bannerTitle, bannerFile, editingBanner, bannerDescription } =
      this.state;
    this.setState({ bannerSaving: true });
    try {
      const fd = new FormData();
      fd.append("page_Name", bannerTitle);
      fd.append("description", bannerDescription);
      fd.append("menu_id", 2);
      if (bannerFile) fd.append("files", bannerFile);
      if (editingBanner) fd.append("BannerID", editingBanner.Banner_id);
      const url = editingBanner
        ? `${API_URL}/api/banners/updateBanner`
        : `${API_URL}/api/banners/addBanner`;
      const res = await fetch(url, { method: "POST", body: fd });
      const json = await res.json();
      this.setState({ bannerSaving: false });
      if (json.status) {
        this.showSuccess(editingBanner ? "Banner updated!" : "Banner saved!");
        setTimeout(() => this.goToBannerList(), 1000);
      } else {
        this.showError(json.message || "Save failed.");
      }
    } catch {
      this.setState({ bannerSaving: false });
      this.showError("Cannot connect to API.");
    }
  };

  deleteBanner = async (id) => {
    if (!window.confirm("Delete this banner?")) return;
    try {
      const res = await fetch(`${API_URL}/api/banners/deleteBanner`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const json = await res.json();
      if (json.message === "Banner deleted successfully") {
        this.showSuccess("Banner deleted.");
        this.fetchBanners();
      } else {
        this.showError(json.message || "Delete failed.");
      }
    } catch {
      this.showError("Cannot connect to API.");
    }
  };

  // ════════════════════
  //  ABOUT SECTION
  // ════════════════════

  fetchAbout = async () => {
    this.setState({ aboutLoading: true });
    try {
      const res = await fetch(`${API_URL}/api/about/getAboutBysectionType`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ section_type: "about" }),
      });
      const json = await res.json();
      if (json.status) {
        this.setState({ aboutList: json.data || [], aboutLoading: false });
      } else {
        this.setState({ aboutLoading: false });
      }
    } catch {
      this.setState({ aboutLoading: false });
      this.showError("Cannot connect to API.");
    }
  };

  openAboutForm = (item = null) => {
    this.setState({
      aboutView: "form",
      editingAbout: item,
      aboutForm: item
        ? {
            title: item.Heading || "",
            subtitle: Array.isArray(item.subHeading)
              ? item.subHeading.join(", ")
              : item.subHeading || "",
            description: item.Description || "",
            images: [],
            saving: false,
          }
        : this.emptyAbout(),
    });
  };

  goToAboutList = () => {
    this.setState({ aboutView: "list", editingAbout: null });
    this.fetchAbout();
  };

  handleAboutImages = (e) => {
    const files = Array.from(e.target.files);
    let loaded = 0;
    const newImages = [];
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        newImages.push({ file, preview: reader.result });
        loaded++;
        if (loaded === files.length)
          this.setState((prev) => ({
            aboutForm: {
              ...prev.aboutForm,
              images: [...prev.aboutForm.images, ...newImages],
            },
          }));
      };
      reader.readAsDataURL(file);
    });
  };

  removeAboutImage = (i) => {
    this.setState((prev) => ({
      aboutForm: {
        ...prev.aboutForm,
        images: prev.aboutForm.images.filter((_, idx) => idx !== i),
      },
    }));
  };

  saveAbout = async () => {
    const { aboutForm, editingAbout } = this.state;
    if (!aboutForm.title.trim()) return this.showError("Title is required.");
    this.setState((prev) => ({
      aboutForm: { ...prev.aboutForm, saving: true },
    }));
    try {
      const fd = new FormData();
      fd.append("Heading", aboutForm.title);
      fd.append("sub_heading", aboutForm.subtitle);
      fd.append("Description", aboutForm.description);
      fd.append("section_type", "about");
      fd.append("eventPerYear", "");
      fd.append("YearofExperience", "");
      fd.append("years_count", "");
      fd.append("years_label", "");
      fd.append("subDescription", "");
      fd.append("globalClients", "");
      aboutForm.images.forEach((img) => fd.append("image", img.file));
      if (editingAbout) fd.append("id", editingAbout.id);
      const url = editingAbout
        ? `${API_URL}/api/about/updateAbout`
        : `${API_URL}/api/about/addAbout`;
      const res = await fetch(url, { method: "POST", body: fd });
      const json = await res.json();
      this.setState((prev) => ({
        aboutForm: { ...prev.aboutForm, saving: false },
      }));
      if (json.status) {
        this.showSuccess(editingAbout ? "Updated!" : "Saved!");
        setTimeout(() => this.goToAboutList(), 1000);
      } else {
        this.showError(json.message || "Save failed.");
      }
    } catch {
      this.setState((prev) => ({
        aboutForm: { ...prev.aboutForm, saving: false },
      }));
      this.showError("Cannot connect to API.");
    }
  };

  deleteAbout = async (idget) => {
    if (!window.confirm("Delete this section?")) return;
    try {
      const res = await fetch(`${API_URL}/api/about/deleteAbout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: idget }),
      });
      const json = await res.json();
      if (json.status) {
        this.showSuccess("Deleted.");
        this.fetchAbout();
      } else this.showError(json.message);
    } catch {
      this.showError("Cannot connect to API.");
    }
  };

  // ════════════════════
  //  MISSION & VISION
  // ════════════════════

  fetchMV = async () => {
    this.setState({ mvLoading: true });
    try {
      const res = await fetch(`${API_URL}/api/about/getAboutBysectionType`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ section_type: "Mission&Vission" }),
      });
      const json = await res.json();
      if (json.status) {
        this.setState({ mvList: json.data || [], mvLoading: false });
      } else {
        this.setState({ mvLoading: false });
      }
    } catch {
      this.setState({ mvLoading: false });
      this.showError("Cannot connect to API.");
    }
  };

  openMVForm = (item = null) => {
    this.setState({
      mvView: "form",
      editingMV: item,
      mvForm: item
        ? {
            heading: item.Heading || "",
            description: item.Description || "",
            saving: false,
          }
        : this.emptyMV(),
    });
  };

  goToMVList = () => {
    this.setState({ mvView: "list", editingMV: null });
    this.fetchMV();
  };

  saveMV = async () => {
    const { mvForm, editingMV } = this.state;
    if (!mvForm.heading.trim()) return this.showError("Heading is required.");
    this.setState((prev) => ({ mvForm: { ...prev.mvForm, saving: true } }));
    try {
      const fd = new FormData();
      fd.append("Heading", mvForm.heading);
      fd.append("sub_heading", "");
      fd.append("Description", mvForm.description);
      fd.append("section_type", "Mission&Vission");
      fd.append("eventPerYear", "");
      fd.append("YearofExperience", "");
      fd.append("years_count", "");
      fd.append("years_label", "");
      fd.append("subDescription", "");
      fd.append("globalClients", "");
      if (editingMV) fd.append("id", editingMV.id);
      const url = editingMV
        ? `${API_URL}/api/about/updateAbout`
        : `${API_URL}/api/about/addAbout`;
      const res = await fetch(url, { method: "POST", body: fd });
      const json = await res.json();
      this.setState((prev) => ({ mvForm: { ...prev.mvForm, saving: false } }));
      if (json.status) {
        this.showSuccess(editingMV ? "Updated!" : "Saved!");
        setTimeout(() => this.goToMVList(), 1000);
      } else {
        this.showError(json.message || "Save failed.");
      }
    } catch {
      this.setState((prev) => ({ mvForm: { ...prev.mvForm, saving: false } }));
      this.showError("Cannot connect to API.");
    }
  };

  deleteMV = async (idget) => {
    if (!window.confirm("Delete this item?")) return;
    try {
      const res = await fetch(`${API_URL}/api/about/deleteAbout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: idget }),
      });
      const json = await res.json();
      if (json.status) {
        this.showSuccess("Deleted.");
        this.fetchMV();
      } else this.showError(json.message);
    } catch {
      this.showError("Cannot connect to API.");
    }
  };

  // ════════════════════
  //  TARGETS
  // ════════════════════

  fetchTargets = async () => {
    this.setState({ targetLoading: true });
    try {
      const res = await fetch(`${API_URL}/api/about/getAboutBysectionType`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ section_type: "Target" }),
      });
      const json = await res.json();
      if (json.status) {
        this.setState({ targetList: json.data || [], targetLoading: false });
      } else {
        this.setState({ targetLoading: false });
      }
    } catch {
      this.setState({ targetLoading: false });
      this.showError("Cannot connect to API.");
    }
  };

  openTargetForm = (item = null) => {
    this.setState({
      targetView: "form",
      editingTarget: item,
      targetForm: item
        ? {
            label: item.Heading || "",
            value: item.Description || "",
            imagePreview: null,
            imageFile: null,
            saving: false,
          }
        : this.emptyTarget(),
    });
  };

  goToTargetList = () => {
    this.setState({ targetView: "list", editingTarget: null });
    this.fetchTargets();
  };

  handleTargetImg = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () =>
      this.setState((prev) => ({
        targetForm: {
          ...prev.targetForm,
          imagePreview: reader.result,
          imageFile: file,
        },
      }));
    reader.readAsDataURL(file);
  };

  saveTarget = async () => {
    const { targetForm, editingTarget } = this.state;
    if (!targetForm.label.trim()) return this.showError("Label is required.");
    this.setState((prev) => ({
      targetForm: { ...prev.targetForm, saving: true },
    }));
    try {
      const fd = new FormData();
      fd.append("Heading", targetForm.label);
      fd.append("Description", targetForm.value);
      fd.append("section_type", "Target");
      fd.append("sub_heading", "");
      fd.append("eventPerYear", "");
      fd.append("YearofExperience", "");
      fd.append("years_count", "");
      fd.append("years_label", "");
      fd.append("subDescription", "");
      fd.append("globalClients", "");
      if (targetForm.imageFile) fd.append("image", targetForm.imageFile);
      if (editingTarget) fd.append("id", editingTarget.id);
      const url = editingTarget
        ? `${API_URL}/api/about/updateAbout`
        : `${API_URL}/api/about/addAbout`;
      const res = await fetch(url, { method: "POST", body: fd });
      const json = await res.json();
      this.setState((prev) => ({
        targetForm: { ...prev.targetForm, saving: false },
      }));
      if (json.status) {
        this.showSuccess(editingTarget ? "Updated!" : "Saved!");
        setTimeout(() => this.goToTargetList(), 1000);
      } else {
        this.showError(json.message || "Save failed.");
      }
    } catch {
      this.setState((prev) => ({
        targetForm: { ...prev.targetForm, saving: false },
      }));
      this.showError("Cannot connect to API.");
    }
  };

  deleteTarget = async (idget) => {
    if (!window.confirm("Delete this target?")) return;
    try {
      const res = await fetch(`${API_URL}/api/about/deleteAbout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: idget }),
      });
      const json = await res.json();
      if (json.status) {
        this.showSuccess("Deleted.");
        this.fetchTargets();
      } else this.showError(json.message);
    } catch {
      this.showError("Cannot connect to API.");
    }
  };

  // ════════════════════
  //  CORE VALUES
  // ════════════════════

  fetchCoreValues = async () => {
    this.setState({ cvLoading: true });
    try {
      const res = await fetch(`${API_URL}/api/about/getAboutBysectionType`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ section_type: "CoreValue" }),
      });
      const json = await res.json();
      if (json.status)
        this.setState({ cvList: json.data || [], cvLoading: false });
      else this.setState({ cvLoading: false });
    } catch {
      this.setState({ cvLoading: false });
      this.showError("Cannot connect to API.");
    }
  };

  openCVForm = (item = null) => {
    this.setState({
      cvView: "form",
      editingCV: item,
      cvForm: item
        ? {
            title: item.Heading || "",
            description: item.Description || "",
            saving: false,
          }
        : this.emptyCoreValue(),
    });
  };

  goToCVList = () => {
    this.setState({ cvView: "list", editingCV: null });
    this.fetchCoreValues();
  };

  saveCV = async () => {
    const { cvForm, editingCV } = this.state;
    if (!cvForm.title.trim()) return this.showError("Title is required.");
    this.setState((prev) => ({ cvForm: { ...prev.cvForm, saving: true } }));
    try {
      const fd = new FormData();
      fd.append("Heading", cvForm.title);
      fd.append("Description", cvForm.description || "");
      fd.append("section_type", "CoreValue");
      fd.append("sub_heading", "");
      fd.append("eventPerYear", "");
      fd.append("YearofExperience", "");
      fd.append("years_count", "");
      fd.append("years_label", "");
      fd.append("subDescription", "");
      fd.append("globalClients", "");
      if (editingCV) fd.append("id", editingCV.id);
      const url = editingCV
        ? `${API_URL}/api/about/updateAbout`
        : `${API_URL}/api/about/addAbout`;
      const res = await fetch(url, { method: "POST", body: fd });
      const json = await res.json();
      this.setState((prev) => ({ cvForm: { ...prev.cvForm, saving: false } }));
      if (json.status) {
        this.showSuccess(editingCV ? "Updated!" : "Saved!");
        setTimeout(() => this.goToCVList(), 1000);
      } else {
        this.showError(json.message || "Save failed.");
      }
    } catch {
      this.setState((prev) => ({ cvForm: { ...prev.cvForm, saving: false } }));
      this.showError("Cannot connect to API.");
    }
  };

  deleteCV = async (idget) => {
    if (!window.confirm("Delete this core value?")) return;
    try {
      const res = await fetch(`${API_URL}/api/about/deleteAbout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: idget }),
      });
      const json = await res.json();
      if (json.status) {
        this.showSuccess("Deleted.");
        this.fetchCoreValues();
      } else this.showError(json.message);
    } catch {
      this.showError("Cannot connect to API.");
    }
  };

  // ════════════════════
  //  ABOUT CARDS
  // ════════════════════

  fetchAboutCard = async () => {
    this.setState({ abLoading: true });
    try {
      const res = await fetch(`${API_URL}/api/about/getAboutBysectionType`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ section_type: "AboutCard" }),
      });
      const json = await res.json();
      if (json.status)
        this.setState({ abList: json.data || [], abLoading: false });
      else this.setState({ abLoading: false });
    } catch {
      this.setState({ abLoading: false });
      this.showError("Cannot connect to API.");
    }
  };

  openABForm = (item = null) => {
    this.setState({
      abView: "form",
      editingAB: item,
      abForm: item
        ? {
            title: item.Heading || "",
            description: item.Description || "",
            saving: false,
          }
        : this.emptyAB(),
    });
  };

  goToABList = () => {
    this.setState({ abView: "list", editingAB: null });
    this.fetchAboutCard();
  };

  saveAB = async () => {
    const { abForm, editingAB } = this.state;
    if (!abForm.title.trim()) return this.showError("Title is required.");
    this.setState((prev) => ({ abForm: { ...prev.abForm, saving: true } }));
    try {
      const fd = new FormData();
      fd.append("Heading", abForm.title);
      fd.append("Description", abForm.description || "");
      fd.append("section_type", "AboutCard");
      fd.append("sub_heading", "");
      fd.append("eventPerYear", "");
      fd.append("YearofExperience", "");
      fd.append("years_count", "");
      fd.append("years_label", "");
      fd.append("subDescription", "");
      fd.append("globalClients", "");
      if (editingAB) fd.append("id", editingAB.id);
      const url = editingAB
        ? `${API_URL}/api/about/updateAbout`
        : `${API_URL}/api/about/addAbout`;
      const res = await fetch(url, { method: "POST", body: fd });
      const json = await res.json();
      this.setState((prev) => ({ abForm: { ...prev.abForm, saving: false } }));
      if (json.status) {
        this.showSuccess(editingAB ? "Updated!" : "Saved!");
        setTimeout(() => this.goToABList(), 1000);
      } else {
        this.showError(json.message || "Save failed.");
      }
    } catch {
      this.setState((prev) => ({ abForm: { ...prev.abForm, saving: false } }));
      this.showError("Cannot connect to API.");
    }
  };

  deleteAB = async (idget) => {
    if (!window.confirm("Delete this about card?")) return;
    try {
      const res = await fetch(`${API_URL}/api/about/deleteAbout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: idget }),
      });
      const json = await res.json();
      if (json.status) {
        this.showSuccess("Deleted.");
        this.fetchAboutCard();
      } else this.showError(json.message);
    } catch {
      this.showError("Cannot connect to API.");
    }
  };

  // ════════════════════
  //  RENDER HELPERS
  // ════════════════════

  renderListHeader = (loading, count, label, onAdd, addLabel) => (
    <div className="rsp-list-top" style={s.listTopBar}>
      <span style={s.countText}>
        {loading
          ? "Loading..."
          : `${count} ${label}${count !== 1 ? "s" : ""} found`}
      </span>
      <button className="rsp-btn-save" style={s.btnSave} onClick={onAdd}>
        {addLabel}
      </button>
    </div>
  );

  renderEmpty = (label, onAdd, addLabel) => (
    <div style={s.emptyBox}>
      <p style={{ ...s.emptyText, marginBottom: "12px" }}>No {label} found.</p>
      <button className="rsp-btn-save" style={s.btnSave} onClick={onAdd}>
        {addLabel}
      </button>
    </div>
  );

  renderActions = (onEdit, onDelete) => (
    <div className="rsp-action-btns" style={s.actionBtns}>
      <button className="rsp-btn-edit" style={s.btnEdit} onClick={onEdit}>
        Edit
      </button>
      <button className="rsp-btn-delete" style={s.btnDelete} onClick={onDelete}>
        Delete
      </button>
    </div>
  );

  renderFormTopBar = (title, onBack) => (
    <div className="rsp-form-top" style={s.formTopBar}>
      <button className="rsp-btn-back" style={s.btnBack} onClick={onBack}>
        Back to List
      </button>
      <h3 style={s.formTitle}>{title}</h3>
    </div>
  );

  renderFormActions = (onCancel, onSave, saving, saveLabel) => (
    <div className="rsp-form-actions" style={s.formActions}>
      <button className="rsp-btn-back" style={s.btnBack} onClick={onCancel}>
        Cancel
      </button>
      <button
        className="rsp-btn-save"
        style={s.btnSave}
        onClick={onSave}
        disabled={saving}
      >
        {saving ? "Saving..." : saveLabel}
      </button>
    </div>
  );

  deleteGalleryImage = async (imageId) => {
    if (!window.confirm("Delete this image permanently?")) return;
    try {
      const res = await fetch(`${API_URL}/api/gallery/deleteGalleryById`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: imageId }),
      });
      const json = await res.json();
      if (json.status) {
        this.showSuccess("Image deleted.");
        // Remove from editingService.imageArray locally — no refetch
        this.setState((prev) => ({
          editingAbout: {
            ...prev.editingAbout,
            imageArray: (prev.editingAbout.imageArray || []).filter(
              (img) => img.image_id !== imageId,
            ),
          },
        }));
      } else {
        this.showError(json.message || "Delete failed.");
      }
    } catch {
      this.showError("Cannot connect to API.");
    }
  };

  // ════════════════════
  //  RENDER
  // ════════════════════
  render() {
    const {
      activeTab,
      bannerView,
      bannerList,
      bannerLoading,
      bannerTitle,
      bannerImagePreview,
      bannerSaving,
      editingBanner,
      bannerDescription,
      aboutView,
      aboutList,
      aboutLoading,
      aboutForm,
      editingAbout,
      mvView,
      mvList,
      mvLoading,
      mvForm,
      editingMV,
      targetView,
      targetList,
      targetLoading,
      targetForm,
      editingTarget,
      cvView,
      cvList,
      cvLoading,
      cvForm,
      editingCV,
      // ✅ About Cards — fixed casing
      abView,
      abList,
      abLoading,
      abForm,
      editingAB,
      successMessage,
      errorMessage,
    } = this.state;

    const TABS = [
      "banner",
      "about",
      "mission",
      "targets",
      "corevalues",
      "aboutcards",
    ];
    const TAB_LABELS = {
      banner: "Banner",
      about: "About Section",
      mission: "Mission & Vision",
      targets: "Targets",
      corevalues: "Core Values",
      aboutcards: "About Cards",
    };

    return (
      <div>
        <div className="page-header">
          <h2>About Page Manager</h2>
          <p>Manage all sections of the About page.</p>
        </div>

        {successMessage && <div style={s.success}>{successMessage}</div>}
        {errorMessage && <div style={s.error}>{errorMessage}</div>}

        <div style={{ ...s.tabRow, flexWrap: "wrap" }}>
          {TABS.map((tab) => (
            <button
              key={tab}
              style={activeTab === tab ? s.tabActive : s.tab}
              onClick={() => this.setState({ activeTab: tab })}
            >
              {TAB_LABELS[tab]}
            </button>
          ))}
        </div>

        {/* ── BANNER ── */}
        {activeTab === "banner" && (
          <div>
            {bannerView === "list" && (
              <div>
                <div className="rsp-list-top" style={s.listTopBar}>
                  <span style={s.countText}>
                    {bannerLoading
                      ? "Loading..."
                      : `${bannerList.length} banner${bannerList.length !== 1 ? "s" : ""} found`}
                  </span>
                  {bannerList.length === 0 && (
                    <button
                      className="rsp-btn-save"
                      style={s.btnSave}
                      onClick={() => this.openBannerForm()}
                    >
                      + Add Banner
                    </button>
                  )}
                </div>
                {bannerLoading && (
                  <div style={s.emptyBox}>
                    <p style={s.emptyText}>Loading...</p>
                  </div>
                )}
                {!bannerLoading &&
                  bannerList.length === 0 &&
                  this.renderEmpty(
                    "banners",
                    () => this.openBannerForm(),
                    "+ Add First Banner",
                  )}
                {!bannerLoading &&
                  bannerList.map((b, i) => (
                    <div
                      key={b.Banner_id || i}
                      className="rsp-list-card"
                      style={s.listCard}
                    >
                      {b.imageUrl ? (
                        <img
                          src={imgUrl(b.imageUrl)}
                          alt="banner"
                          className="rsp-thumb-wide"
                          style={s.thumbWide}
                        />
                      ) : (
                        <div style={s.thumbPlaceholder}>No Image</div>
                      )}
                      <div style={{ flex: 1 }}>
                        <div style={s.cardTitle}>
                          {b.Page_Name || "—"}{" "}
                          <span style={s.idBadge}>ID: {b.Banner_id}</span>
                        </div>
                        <p style={s.dateText}>
                          Added:{" "}
                          {new Date(b.created_at).toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                        </p>
                        {(b.Description || b.description) && (
                          <p
                            style={{
                              fontSize: "12px",
                              color: "#666",
                              marginTop: "4px",
                            }}
                          >
                            {(b.Description || b.description).substring(0, 120)}
                            {(b.Description || b.description).length > 120
                              ? "..."
                              : ""}
                          </p>
                        )}
                      </div>
                      {this.renderActions(
                        () => this.openBannerForm(b),
                        () => this.deleteBanner(b.Banner_id),
                      )}
                    </div>
                  ))}
              </div>
            )}
            {bannerView === "form" && (
              <div>
                {this.renderFormTopBar(
                  editingBanner
                    ? `Edit Banner — ID ${editingBanner.Banner_id}`
                    : "Add New Banner",
                  this.goToBannerList,
                )}
                <div className="card">
                  <div className="rsp-form-group" style={s.formGroup}>
                    {editingBanner &&
                      !bannerImagePreview &&
                      editingBanner.imageUrl && (
                        <div style={{ marginBottom: "10px" }}>
                          <p style={s.hint}>
                            Current image (leave empty to keep this image):
                          </p>
                          <img
                            src={imgUrl(editingBanner.imageUrl)}
                            alt="current"
                            style={s.currentImg}
                          />
                        </div>
                      )}
                    {bannerImagePreview ? (
                      <div className="rsp-preview-box" style={s.previewBox}>
                        <img
                          src={bannerImagePreview}
                          alt="preview"
                          style={s.previewImg}
                        />
                        <div style={s.overlay}>
                          <button
                            className="rsp-btn-delete"
                            style={s.btnDelete}
                            onClick={() =>
                              this.setState({
                                bannerImagePreview: null,
                                bannerFile: null,
                              })
                            }
                          >
                            Remove
                          </button>
                          <label className="rsp-btn-dark" style={s.btnDark}>
                            Change
                            <input
                              type="file"
                              accept="image/*"
                              onChange={this.handleBannerImg}
                              style={{ display: "none" }}
                            />
                          </label>
                        </div>
                      </div>
                    ) : (
                      <label className="rsp-upload-box" style={s.uploadBox}>
                        <p style={s.uploadText}>
                          {editingBanner
                            ? "Click to upload new image (optional)"
                            : "Click to upload banner"}
                        </p>
                        <p style={s.uploadHint}>1920x600px recommended</p>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={this.handleBannerImg}
                          style={{ display: "none" }}
                        />
                      </label>
                    )}
                  </div>
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Banner Title</label>
                    <input
                      className="rsp-input"
                      style={s.input}
                      type="text"
                      disabled
                      value={bannerTitle}
                      onChange={(e) =>
                        this.setState({ bannerTitle: e.target.value })
                      }
                      placeholder="e.g. About"
                    />
                  </div>
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Banner Description</label>
                    <textarea
                      className="rsp-textarea"
                      style={s.textarea}
                      value={bannerDescription}
                      onChange={(e) =>
                        this.setState({ bannerDescription: e.target.value })
                      }
                      placeholder="e.g. Learn more about TNA Events..."
                    />
                  </div>
                  {this.renderFormActions(
                    this.goToBannerList,
                    this.saveBanner,
                    bannerSaving,
                    editingBanner ? "Update Banner" : "Save Banner",
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* ── ABOUT SECTION ── */}
        {activeTab === "about" && (
          <div>
            {aboutView === "list" && (
              <div>
                <div className="rsp-list-top" style={s.listTopBar}>
                  <span style={s.countText}>
                    {aboutLoading
                      ? "Loading..."
                      : `${aboutList.length} section${aboutList.length !== 1 ? "s" : ""} found`}
                  </span>
                  {aboutList.length === 0 && (
                    <button
                      className="rsp-btn-save"
                      style={s.btnSave}
                      onClick={() => this.openAboutForm()}
                    >
                      + Add About Section
                    </button>
                  )}
                </div>
                {aboutLoading && (
                  <div style={s.emptyBox}>
                    <p style={s.emptyText}>Loading...</p>
                  </div>
                )}
                {!aboutLoading &&
                  aboutList.length === 0 &&
                  this.renderEmpty(
                    "about sections",
                    () => this.openAboutForm(),
                    "+ Add First Section",
                  )}
                {!aboutLoading &&
                  aboutList.map((item, i) => {
                    const firstImage = item.images
                      ? item.images.split(",")[0].trim()
                      : null;
                    return (
                      <div
                        key={item.id || i}
                        className="rsp-list-card"
                        style={s.listCard}
                      >
                        {firstImage ? (
                          <img
                            src={imgUrl(firstImage)}
                            alt="about"
                            className="rsp-thumb-wide"
                            style={s.thumbWide}
                          />
                        ) : (
                          <div style={s.thumbPlaceholder}>No Image</div>
                        )}
                        <div style={{ flex: 1 }}>
                          <div style={s.cardTitle}>
                            {item.Heading || "—"}{" "}
                            <span style={s.idBadge}>ID: {item.id}</span>
                          </div>
                          {item.subHeading && item.subHeading.length > 0 && (
                            <p style={s.subtitleText}>
                              {Array.isArray(item.subHeading)
                                ? item.subHeading.join(", ")
                                : item.subHeading}
                            </p>
                          )}
                          {item.Description && (
                            <p style={s.dateText}>
                              {item.Description.replace(
                                /<[^>]*>/g,
                                "",
                              ).substring(0, 120)}
                              ...
                            </p>
                          )}
                          {item.images && (
                            <p
                              style={{
                                fontSize: "11px",
                                color: "#aaa",
                                marginTop: "4px",
                              }}
                            >
                              {item.images.split(",").length} image(s)
                            </p>
                          )}
                        </div>
                        {this.renderActions(
                          () => this.openAboutForm(item),
                          () => this.deleteAbout(item.id),
                        )}
                      </div>
                    );
                  })}
              </div>
            )}
            {aboutView === "form" && (
              <div>
                {this.renderFormTopBar(
                  editingAbout
                    ? `Edit — ${editingAbout.Heading}`
                    : "Add New About Section",
                  this.goToAboutList,
                )}
                <div className="card">
                  <div className="rsp-two-col" style={s.twoCol}>
                    <div className="rsp-form-group" style={s.formGroup}>
                      <label style={s.label}>Title (Heading) *</label>
                      <input
                        className="rsp-input"
                        style={s.input}
                        type="text"
                        value={aboutForm.title}
                        placeholder="e.g. India's Premier Event Architects"
                        onChange={(e) =>
                          this.setState((p) => ({
                            aboutForm: {
                              ...p.aboutForm,
                              title: e.target.value,
                            },
                          }))
                        }
                      />
                    </div>
                    <div className="rsp-form-group" style={s.formGroup}>
                      <label style={s.label}>Subtitle</label>
                      <input
                        className="rsp-input"
                        style={s.input}
                        type="text"
                        value={aboutForm.subtitle}
                        placeholder="e.g. ABOUT TNA"
                        onChange={(e) =>
                          this.setState((p) => ({
                            aboutForm: {
                              ...p.aboutForm,
                              subtitle: e.target.value,
                            },
                          }))
                        }
                      />
                    </div>
                  </div>
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Description</label>
                    <RichTextEditor
                      value={aboutForm.description}
                      onChange={(val) =>
                        this.setState((p) => ({
                          aboutForm: { ...p.aboutForm, description: val },
                        }))
                      }
                    />
                  </div>
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>
                      Section Images{" "}
                      <span style={{ color: "#aaa", fontWeight: "400" }}>
                        (multiple)
                      </span>
                    </label>

                      {editingAbout &&
                      (() => {
                        const validImages = (
                          editingAbout.imageArray || []
                        ).filter((img) => img.image_id && img.image_url);

                        if (validImages.length === 0) {
                          return (
                            <div style={{ marginBottom: "10px" }}>
                              <p style={s.hint}>No images uploaded yet.</p>
                            </div>
                          );
                        }

                        return (
                          <div style={{ marginBottom: "10px" }}>
                            <p style={s.hint}>
                              Current gallery ({validImages.length} image(s)):
                            </p>
                            <div className="rsp-image-grid" style={s.imageGrid}>
                              {validImages.map((img) => (
                                <div
                                  key={img.image_id}
                                  style={{ position: "relative" }}
                                >
                                  <img
                                    src={imgUrl(img.image_url)}
                                    alt={`gallery-${img.image_id}`}
                                    style={s.imgThumb}
                                  />
                                  <button
                                    type="button"
                                    title="Delete image permanently"
                                    style={s.deleteImgBtn}
                                    onClick={() =>
                                      this.deleteGalleryImage(img.image_id)
                                    }
                                  >
                                    ×
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        );
                      })()}


                 
                    {aboutForm.images.length > 0 && (
                      <div style={{ marginBottom: "10px" }}>
                        <p style={s.hint}>
                          {aboutForm.images.length} new image(s) selected:
                        </p>
                        <div className="rsp-image-grid" style={s.imageGrid}>
                          {aboutForm.images.map((img, i) => (
                            <div key={i} style={{ position: "relative" }}>
                              <img
                                src={img.preview}
                                alt=""
                                style={s.imgThumb}
                              />
                              <button
                                style={s.removeImgBtn}
                                onClick={() => this.removeAboutImage(i)}
                              >
                                X
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                    <label className="rsp-upload-box" style={s.uploadBox}>
                      <p style={s.uploadText}>Click to select images</p>
                      <p style={s.uploadHint}>
                        Use Ctrl+Click to select multiple
                      </p>
                      <input
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={this.handleAboutImages}
                        style={{ display: "none" }}
                      />
                    </label>
                  </div>
                  {this.renderFormActions(
                    this.goToAboutList,
                    this.saveAbout,
                    aboutForm.saving,
                    editingAbout ? "Update Section" : "Save Section",
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* ── MISSION & VISION ── */}
        {activeTab === "mission" && (
          <div>
            {mvView === "list" && (
              <div>
                {mvList.length < 2 &&
                  this.renderListHeader(
                    mvLoading,
                    mvList.length,
                    "item",
                    () => this.openMVForm(),
                    "+ Add Mission/Vision",
                  )}
                {mvLoading && (
                  <div style={s.emptyBox}>
                    <p style={s.emptyText}>Loading...</p>
                  </div>
                )}
                {!mvLoading &&
                  mvList.length === 0 &&
                  this.renderEmpty(
                    "mission/vision items",
                    () => this.openMVForm(),
                    "+ Add First Item",
                  )}
                {!mvLoading &&
                  mvList.map((item, i) => (
                    <div
                      key={item.id || i}
                      className="rsp-list-card"
                      style={s.listCard}
                    >
                      <div
                        style={{
                          ...s.typeBadgeLg,
                          background: "#e8f4fd",
                          color: "#1565c0",
                        }}
                      >
                        {item.Heading?.toLowerCase().includes("mission")
                          ? "Mission"
                          : "Vision"}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={s.cardTitle}>
                          {item.Heading || "—"}{" "}
                          <span style={s.idBadge}>ID: {item.id}</span>
                        </div>
                        {item.Description && (
                          <p style={s.dateText}>
                            {item.Description.replace(/<[^>]*>/g, "").substring(
                              0,
                              120,
                            )}
                          </p>
                        )}
                      </div>
                      {this.renderActions(
                        () => this.openMVForm(item),
                        () => this.deleteMV(item.id),
                      )}
                    </div>
                  ))}
              </div>
            )}
            {mvView === "form" && (
              <div>
                {this.renderFormTopBar(
                  editingMV
                    ? `Edit — ${editingMV.Heading}`
                    : "Add Mission / Vision",
                  this.goToMVList,
                )}
                <div className="card">
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Heading *</label>
                    <input
                      className="rsp-input"
                      style={s.input}
                      type="text"
                      value={mvForm.heading}
                      placeholder="e.g. Our Vision"
                      onChange={(e) =>
                        this.setState((p) => ({
                          mvForm: { ...p.mvForm, heading: e.target.value },
                        }))
                      }
                    />
                  </div>
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Description</label>
                    <RichTextEditor
                      value={mvForm.description}
                      onChange={(val) =>
                        this.setState((p) => ({
                          mvForm: { ...p.mvForm, description: val },
                        }))
                      }
                    />
                  </div>
                  {this.renderFormActions(
                    this.goToMVList,
                    this.saveMV,
                    mvForm.saving,
                    editingMV ? "Update" : "Save",
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* ── TARGETS ── */}
        {activeTab === "targets" && (
          <div>
            {targetView === "list" && (
              <div>
                {targetList.length < 3 &&
                  this.renderListHeader(
                    targetLoading,
                    targetList.length,
                    "target",
                    () => this.openTargetForm(),
                    "+ Add Target",
                  )}
                {targetLoading && (
                  <div style={s.emptyBox}>
                    <p style={s.emptyText}>Loading...</p>
                  </div>
                )}
                {!targetLoading &&
                  targetList.length === 0 &&
                  this.renderEmpty(
                    "targets",
                    () => this.openTargetForm(),
                    "+ Add First Target",
                  )}
                {!targetLoading && targetList.length > 0 && (
                  <div className="rsp-target-grid" style={s.targetGrid}>
                    {targetList.map((item, i) => (
                      <div key={item.id || i} style={s.targetCard}>
                        {item.images && (
                          <img
                            src={imgUrl(item.images)}
                            alt={item.Heading}
                            style={s.targetImg}
                          />
                        )}
                        <div style={s.targetValue}>
                          {item.Description || "—"}
                        </div>
                        <div style={s.targetLabel}>{item.Heading || "—"}</div>
                        <span style={s.idBadge}>ID: {item.id}</span>
                        <div
                          style={{
                            display: "flex",
                            gap: "6px",
                            marginTop: "6px",
                            width: "100%",
                          }}
                        >
                          <button
                            style={s.btnEditSm}
                            onClick={() => this.openTargetForm(item)}
                          >
                            Edit
                          </button>
                          <button
                            style={s.btnDeleteSm}
                            onClick={() => this.deleteTarget(item.id)}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            {targetView === "form" && (
              <div>
                {this.renderFormTopBar(
                  editingTarget
                    ? `Edit — ${editingTarget.Heading}`
                    : "Add New Target",
                  this.goToTargetList,
                )}
                <div className="card">
                  <div className="rsp-two-col" style={s.twoCol}>
                    <div className="rsp-form-group" style={s.formGroup}>
                      <label style={s.label}>
                        Label *{" "}
                        <span style={{ color: "#aaa", fontWeight: "400" }}>
                          (e.g. Years of Experience)
                        </span>
                      </label>
                      <input
                        className="rsp-input"
                        style={s.input}
                        type="text"
                        value={targetForm.label}
                        placeholder="e.g. Years of Experience"
                        onChange={(e) =>
                          this.setState((p) => ({
                            targetForm: {
                              ...p.targetForm,
                              label: e.target.value,
                            },
                          }))
                        }
                      />
                    </div>
                    <div className="rsp-form-group" style={s.formGroup}>
                      <label style={s.label}>
                        Value *{" "}
                        <span style={{ color: "#aaa", fontWeight: "400" }}>
                          (e.g. 8+)
                        </span>
                      </label>
                      <input
                        className="rsp-input"
                        style={s.input}
                        type="text"
                        value={targetForm.value}
                        placeholder="e.g. 8+"
                        onChange={(e) =>
                          this.setState((p) => ({
                            targetForm: {
                              ...p.targetForm,
                              value: e.target.value,
                            },
                          }))
                        }
                      />
                    </div>
                  </div>
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>
                      Background Image{" "}
                      <span style={{ color: "#aaa", fontWeight: "400" }}>
                        (optional)
                      </span>
                    </label>
                    {editingTarget &&
                      !targetForm.imagePreview &&
                      editingTarget.images && (
                        <div style={{ marginBottom: "10px" }}>
                          <p style={s.hint}>Current:</p>
                          <img
                            src={imgUrl(editingTarget.images)}
                            alt="current"
                            style={s.currentImg}
                          />
                        </div>
                      )}
                    {targetForm.imagePreview ? (
                      <div
                        style={{
                          display: "flex",
                          gap: "12px",
                          alignItems: "flex-start",
                        }}
                      >
                        <img
                          src={targetForm.imagePreview}
                          alt="preview"
                          style={s.currentImg}
                        />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "6px",
                          }}
                        >
                          <label className="rsp-btn-dark" style={s.btnDark}>
                            Change
                            <input
                              type="file"
                              accept="image/*"
                              onChange={this.handleTargetImg}
                              style={{ display: "none" }}
                            />
                          </label>
                          <button
                            className="rsp-btn-delete"
                            style={s.btnDelete}
                            onClick={() =>
                              this.setState((p) => ({
                                targetForm: {
                                  ...p.targetForm,
                                  imagePreview: null,
                                  imageFile: null,
                                },
                              }))
                            }
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    ) : (
                      <label className="rsp-upload-box" style={s.uploadBox}>
                        <p style={s.uploadText}>
                          Click to upload background image
                        </p>
                        <p style={s.uploadHint}>JPG, PNG</p>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={this.handleTargetImg}
                          style={{ display: "none" }}
                        />
                      </label>
                    )}
                  </div>
                  {this.renderFormActions(
                    this.goToTargetList,
                    this.saveTarget,
                    targetForm.saving,
                    editingTarget ? "Update Target" : "Save Target",
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* ── CORE VALUES ── */}
        {activeTab === "corevalues" && (
          <div>
            {cvView === "list" && (
              <div>
                {cvList.length < 5 &&
                  this.renderListHeader(
                    cvLoading,
                    cvList.length,
                    "core value",
                    () => this.openCVForm(),
                    "+ Add Core Value",
                  )}
                {cvLoading && (
                  <div style={s.emptyBox}>
                    <p style={s.emptyText}>Loading...</p>
                  </div>
                )}
                {!cvLoading &&
                  cvList.length === 0 &&
                  this.renderEmpty(
                    "core values",
                    () => this.openCVForm(),
                    "+ Add First Core Value",
                  )}
                {!cvLoading && cvList.length > 0 && (
                  <div className="rsp-cv-grid" style={s.cvGrid}>
                    {cvList.map((item, i) => (
                      <div key={item.id || i} style={s.cvCard}>
                        <strong style={s.cvTitle}>{item.Heading || "—"}</strong>
                        <p style={s.cvDesc}>{item.Description || ""}</p>
                        <div
                          style={{
                            display: "flex",
                            gap: "6px",
                            marginTop: "auto",
                          }}
                        >
                          <button
                            style={s.btnEditSm}
                            onClick={() => this.openCVForm(item)}
                          >
                            Edit
                          </button>
                          <button
                            style={s.btnDeleteSm}
                            onClick={() => this.deleteCV(item.id)}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            {cvView === "form" && (
              <div>
                {this.renderFormTopBar(
                  editingCV
                    ? `Edit — ${editingCV.Heading}`
                    : "Add New Core Value",
                  this.goToCVList,
                )}
                <div className="card">
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Title *</label>
                    <input
                      className="rsp-input"
                      style={s.input}
                      type="text"
                      value={cvForm.title}
                      placeholder="e.g. Innovation"
                      onChange={(e) =>
                        this.setState((p) => ({
                          cvForm: { ...p.cvForm, title: e.target.value },
                        }))
                      }
                    />
                  </div>
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Description</label>
                    <textarea
                      className="rsp-textarea"
                      style={s.textarea}
                      value={cvForm.description}
                      placeholder="Describe this core value..."
                      onChange={(e) =>
                        this.setState((p) => ({
                          cvForm: { ...p.cvForm, description: e.target.value },
                        }))
                      }
                    />
                  </div>
                  {this.renderFormActions(
                    this.goToCVList,
                    this.saveCV,
                    cvForm.saving,
                    editingCV ? "Update Core Value" : "Save Core Value",
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* ── ABOUT CARDS ── */}
        {activeTab === "aboutcards" && (
          <div>
            {abView === "list" && (
              <div>
                {abList.length < 5 &&
                  this.renderListHeader(
                    abLoading,
                    abList.length,
                    "about card",
                    () => this.openABForm(),
                    "+ Add About Card",
                  )}
                {abLoading && (
                  <div style={s.emptyBox}>
                    <p style={s.emptyText}>Loading...</p>
                  </div>
                )}
                {!abLoading &&
                  abList.length === 0 &&
                  this.renderEmpty(
                    "about cards",
                    () => this.openABForm(),
                    "+ Add First About Card",
                  )}
                {!abLoading && abList.length > 0 && (
                  <div className="rsp-ab-grid" style={s.abGrid}>
                    {abList.map((item, i) => (
                      <div key={item.id || i} style={s.abCard}>
                        <strong style={s.cvTitle}>{item.Heading || "—"}</strong>
                        <p style={s.cvDesc}>{item.Description || ""}</p>
                        <div
                          style={{
                            display: "flex",
                            gap: "6px",
                            marginTop: "auto",
                          }}
                        >
                          <button
                            style={s.btnEditSm}
                            onClick={() => this.openABForm(item)}
                          >
                            Edit
                          </button>
                          <button
                            style={s.btnDeleteSm}
                            onClick={() => this.deleteAB(item.id)}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            {abView === "form" && (
              <div>
                {this.renderFormTopBar(
                  editingAB
                    ? `Edit — ${editingAB.Heading}`
                    : "Add New About Card",
                  this.goToABList,
                )}
                <div className="card">
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Title *</label>
                    <input
                      className="rsp-input"
                      style={s.input}
                      type="text"
                      value={abForm.title}
                      placeholder="e.g. Innovation"
                      onChange={(e) =>
                        this.setState((p) => ({
                          abForm: { ...p.abForm, title: e.target.value },
                        }))
                      }
                    />
                  </div>
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Description</label>
                    <textarea
                      className="rsp-textarea"
                      style={s.textarea}
                      value={abForm.description}
                      placeholder="Describe this about card..."
                      onChange={(e) =>
                        this.setState((p) => ({
                          abForm: { ...p.abForm, description: e.target.value },
                        }))
                      }
                    />
                  </div>
                  {this.renderFormActions(
                    this.goToABList,
                    this.saveAB,
                    abForm.saving,
                    editingAB ? "Update About Card" : "Save About Card",
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const s = {
  success: {
    background: "#e8f5e9",
    color: "#2e7d32",
    border: "1px solid #c8e6c9",
    borderRadius: "8px",
    padding: "12px 16px",
    marginBottom: "16px",
    fontSize: "14px",
  },
  error: {
    background: "#ffebee",
    color: "#c62828",
    border: "1px solid #ffcdd2",
    borderRadius: "8px",
    padding: "12px 16px",
    marginBottom: "16px",
    fontSize: "14px",
  },
  tabRow: {
    display: "flex",
    gap: "6px",
    borderBottom: "2px solid #e8e8e8",
    marginBottom: "20px",
  },
  tab: {
    padding: "10px 16px",
    background: "none",
    border: "none",
    borderBottom: "3px solid transparent",
    fontSize: "13px",
    color: "#888",
    cursor: "pointer",
    marginBottom: "-2px",
    fontWeight: "500",
    whiteSpace: "nowrap",
  },
  tabActive: {
    padding: "10px 16px",
    background: "none",
    border: "none",
    borderBottom: "3px solid #e8a020",
    fontSize: "13px",
    color: "#e8a020",
    cursor: "pointer",
    marginBottom: "-2px",
    fontWeight: "600",
    whiteSpace: "nowrap",
  },
  listTopBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
  },
  countText: { fontSize: "14px", color: "#888" },
  listCard: {
    background: "white",
    borderRadius: "10px",
    padding: "16px 18px",
    border: "1px solid #e8e8e8",
    marginBottom: "12px",
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  cardTitle: {
    fontSize: "15px",
    color: "#1a1a2e",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "4px",
  },
  subtitleText: {
    fontSize: "12px",
    color: "#e8a020",
    fontWeight: "500",
    marginBottom: "4px",
  },
  idBadge: {
    background: "#f0f2f5",
    color: "#888",
    border: "1px solid #e0e0e0",
    borderRadius: "10px",
    padding: "2px 8px",
    fontSize: "11px",
    fontWeight: "400",
  },
  dateText: { fontSize: "12px", color: "#888" },
  emptyBox: {
    background: "white",
    borderRadius: "10px",
    padding: "48px 20px",
    border: "1px solid #e8e8e8",
    textAlign: "center",
  },
  emptyText: { color: "#aaa", fontSize: "14px" },
  thumbWide: {
    width: "120px",
    height: "65px",
    objectFit: "cover",
    borderRadius: "6px",
    border: "1px solid #e8e8e8",
    flexShrink: 0,
  },
  thumbPlaceholder: {
    width: "120px",
    height: "65px",
    background: "#f0f2f5",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "11px",
    color: "#aaa",
    flexShrink: 0,
  },
  actionBtns: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    flexShrink: 0,
  },
  btnEdit: {
    background: "#e3f2fd",
    color: "#1565c0",
    border: "1px solid #bbdefb",
    padding: "6px 14px",
    borderRadius: "6px",
    fontSize: "12px",
    cursor: "pointer",
    fontWeight: "600",
    minWidth: "64px",
  },
  btnDelete: {
    background: "#ffebee",
    color: "#c62828",
    border: "1px solid #ffcdd2",
    padding: "6px 14px",
    borderRadius: "6px",
    fontSize: "12px",
    cursor: "pointer",
    fontWeight: "600",
    minWidth: "64px",
  },
  btnEditSm: {
    background: "#e3f2fd",
    color: "#1565c0",
    border: "1px solid #bbdefb",
    padding: "4px 10px",
    borderRadius: "5px",
    fontSize: "11px",
    cursor: "pointer",
    fontWeight: "600",
    flex: 1,
  },
  btnDeleteSm: {
    background: "#ffebee",
    color: "#c62828",
    border: "1px solid #ffcdd2",
    padding: "4px 10px",
    borderRadius: "5px",
    fontSize: "11px",
    cursor: "pointer",
    fontWeight: "600",
    flex: 1,
  },
  typeBadgeLg: {
    padding: "6px 14px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "700",
    flexShrink: 0,
  },
  formTopBar: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginBottom: "16px",
  },
  formTitle: { fontSize: "16px", color: "#1a1a2e", margin: 0 },
  formActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    borderTop: "1px solid #f0f0f0",
    paddingTop: "16px",
  },
  formGroup: { marginBottom: "18px" },
  label: {
    display: "block",
    fontSize: "13px",
    color: "#555",
    fontWeight: "600",
    marginBottom: "6px",
  },
  input: {
    width: "100%",
    padding: "10px 14px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    fontSize: "14px",
    outline: "none",
    fontFamily: "Arial, sans-serif",
  },
  textarea: {
    width: "100%",
    padding: "10px 14px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    fontSize: "14px",
    outline: "none",
    minHeight: "100px",
    resize: "vertical",
    fontFamily: "Arial, sans-serif",
  },
  select: {
    width: "100%",
    padding: "10px 14px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    fontSize: "14px",
    outline: "none",
    background: "white",
    cursor: "pointer",
  },
  uploadBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: "2px dashed #ddd",
    borderRadius: "10px",
    padding: "28px 20px",
    cursor: "pointer",
    background: "#fafafa",
    textAlign: "center",
  },
  uploadText: { fontSize: "14px", color: "#555", marginBottom: "4px" },
  uploadHint: { fontSize: "11px", color: "#aaa" },
  previewBox: {
    position: "relative",
    borderRadius: "10px",
    overflow: "hidden",
    border: "1px solid #e8e8e8",
  },
  previewImg: {
    width: "100%",
    height: "200px",
    objectFit: "cover",
    display: "block",
  },
  currentImg: {
    width: "180px",
    height: "80px",
    objectFit: "cover",
    borderRadius: "6px",
    border: "1px solid #e8e8e8",
  },
  overlay: {
    position: "absolute",
    bottom: "10px",
    right: "10px",
    display: "flex",
    gap: "8px",
  },
  imageGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(6, 1fr)",
    gap: "8px",
    marginBottom: "10px",
  },
  imgThumb: {
    width: "100%",
    aspectRatio: "1",
    objectFit: "cover",
    borderRadius: "6px",
    border: "1px solid #e8e8e8",
  },
  removeImgBtn: {
    position: "absolute",
    top: "2px",
    right: "2px",
    width: "18px",
    height: "18px",
    background: "#e53935",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    fontSize: "10px",
    cursor: "pointer",
    fontWeight: "700",
  },
  hint: { fontSize: "12px", color: "#888", marginBottom: "6px" },
  btnDark: {
    background: "#1a1a2e",
    color: "#fff",
    border: "none",
    padding: "7px 14px",
    borderRadius: "6px",
    fontSize: "12px",
    cursor: "pointer",
    fontWeight: "600",
  },
  btnSave: {
    background: "#e8a020",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },
  btnBack: {
    background: "#f0f2f5",
    color: "#333",
    border: "1px solid #ddd",
    padding: "9px 16px",
    borderRadius: "8px",
    fontSize: "13px",
    cursor: "pointer",
    fontWeight: "500",
  },
  twoCol: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" },
  targetGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "14px",
  },
  targetCard: {
    background: "white",
    borderRadius: "10px",
    padding: "20px 16px",
    border: "1px solid #e8e8e8",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "6px",
  },
  targetImg: {
    width: "60px",
    height: "40px",
    objectFit: "cover",
    borderRadius: "6px",
    marginBottom: "4px",
  },
  targetValue: { fontSize: "24px", fontWeight: "700", color: "#1a1a2e" },
  targetLabel: { fontSize: "12px", color: "#888", fontWeight: "500" },
  cvGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "14px",
  },
  cvCard: {
    background: "white",
    borderRadius: "10px",
    padding: "20px",
    border: "1px solid #e8e8e8",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    minHeight: "140px",
  },
  cvTitle: { fontSize: "15px", color: "#1a1a2e" },
  cvDesc: { fontSize: "13px", color: "#666", lineHeight: "1.6", flex: 1 },
  // ✅ About Cards styles
  abGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "14px",
  },
  abCard: {
    background: "white",
    borderRadius: "10px",
    padding: "20px",
    border: "1px solid #e8e8e8",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    minHeight: "140px",
  },
  deleteImgBtn: {
    position: "absolute",
    top: "4px",
    right: "4px",
    width: "24px",
    height: "24px",
    background: "#e53935",
    color: "#fff",
    border: "2px solid #fff",
    borderRadius: "50%",
    fontSize: "16px",
    cursor: "pointer",
    fontWeight: "700",
    lineHeight: "1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.25)",
    padding: 0,
  },
};

export default AboutUs;
